import { render, staticRenderFns } from "./Report8Summary.vue?vue&type=template&id=3b0f60d6&scoped=true&"
import script from "./Report8Summary.vue?vue&type=script&lang=js&"
export * from "./Report8Summary.vue?vue&type=script&lang=js&"
import style0 from "./Report8Summary.vue?vue&type=style&index=0&id=3b0f60d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f60d6",
  null
  
)

export default component.exports